import type { TDataExportValueTypesTimeseriesAggregation } from 'App/data-export/types/from-code-gen/TDataExportValueTypesTimeseriesAggregation'
import { translate } from 'i18n/i18n'

export const mapAggregationToLabel: Record<TDataExportValueTypesTimeseriesAggregation, () => string> = {
  DAILY: () => translate.phrases.banyanApp('Daily'),
  HOURLY: () => translate.phrases.banyanApp('Hourly'),
  UNAGGREGATED: () => translate.phrases.banyanApp('Ten-Minutely'),
}
